import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { InformativeMessage } from '@models/swagger';
import { InformativeMessagesParams } from './service';

export enum InformativeMessagesActions {
  Failure = '[Application Utilities InformativeMessages] Failure',
  Request = '[Application Utilities InformativeMessages] Request',
  Success = '[Application Utilities InformativeMessages] Success',
}

export const InformativeMessagesFailure = createAction(
  InformativeMessagesActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const InformativeMessagesRequest = createAction(
  InformativeMessagesActions.Request,
  props<{ parameters?: InformativeMessagesParams }>()
);

export const InformativeMessagesSuccess = createAction(
  InformativeMessagesActions.Success,
  props<{ data: InformativeMessage[] }>()
);
